
var React = require("react");
var ActionButton = require("../generic/ActionButton.jsx");
var DataActionUtil = require("../../../util/DataActionUtil.js");

class RestoreInfoButton extends React.Component  {
    constructor(){
        super()
    }

    render(){

        return <ActionButton 
                    {...this.props}
                    text="Restore"
                    action={DataActionUtil.restoreAsset}
                    mainClass="delete"
                >
               </ActionButton>
    }
}

module.exports = RestoreInfoButton;